import 'vant/lib/area/index.less'

// 依赖
import '../preview-text/style'
